import { useUnsavedChangesWarning } from '@app/core/hooks';
import type { auditReports } from '@mi-front/api-clients';
import { Box, Stack } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { Languages } from '../../types';
import { useReportDefinitionForm } from '../hooks/useReportDefinitionForm';
import { ReportDefinitionActions } from './actions/ReportDefinitionActions';
import { BrandingEditor } from './branding/BrandingEditor';
import { DefinitionMetadataEditor } from './DefinitionMetadataEditor';
import { SectionTabs } from './section/SectionTabs';

interface Props {
  blueprint: auditReports.BlueprintMetadataDto;
  definition: auditReports.GetReportDefinitionByReportTypeQueryResponse;
  languages?: Languages;
}

export function ReportDefinitionEditor({ definition }: Props) {
  const { form } = useReportDefinitionForm(definition);

  useUnsavedChangesWarning({
    isDirty: form.formState.isDirty,
  });

  return (
    <FormProvider {...form}>
      <Stack gap={2}>
        <DefinitionMetadataEditor />
        <BrandingEditor />
        <SectionTabs />
      </Stack>

      <Box mt={4}>
        <ReportDefinitionActions />
      </Box>
    </FormProvider>
  );
}
